import AnalyticsContext from './AnalyticsContext';
import Link from './Link';

const FooterNav = (props) => {
	let containerClass = 'footer-nav ';
	if (props.customClass) {
		containerClass += props.customClass;
	}
	let contentClass = 'footer-nav-content ';
	if (!props.next) {
		contentClass += 'only-prev';
	} else if (!props.prev) {
		contentClass += 'only-next';
	}

	const transition = props.disableTransition ? false : true;

	return (
		<AnalyticsContext type="div" className={containerClass} componentName="FooterNav">
			<div className={contentClass}>
				{props.prev ? <Link text={props.prev.text} href={props.prev.url} className={props.prev.external === true ? "arrow-nav": props.prev.explore === true ? "arrow-nav explore-nissan-cta" : "arrow-nav prev"} newTab={props.prev.external} transition={props.prev.explore !== true ? transition : ""} /> : ''}
				{props.centerText ? <p>{props.centerText}</p> : ''}
				{props.next ? <Link text={props.next.text} href={props.next.url} className="arrow-nav next" transition={transition} /> : ''}
			</div>
		</AnalyticsContext>
	);
};

export default FooterNav;
